import { createLucideIcon } from 'lucide-react';

export const PlaySolid = createLucideIcon('PlaySolid', [
  [
    'path',
    {
      d: 'M4.6 2.1c.3-.2.7-.1 1 0l15 9c.2.2.4.6.4.9 0 .3-.2.7-.5.8l-14.9 9c-.3.2-.7.3-1 0A1 1 0 0 1 4 21V3c0-.4.2-.7.6-.9Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
